import React, { useState, useEffect } from "react";
import { Link } from "gatsby";
import { useLocation } from "@reach/router";

import "../../styles/components/locale-selector.scss";

const LocaleSelector = () => {
	const location = useLocation();
	const [pathGr, setPathGr] = useState("/");
	const [pathEn, setPathEn] = useState("/en/");

	useEffect(() => {
		let pagePath = location.pathname;

		switch (pagePath) {
			case "/":
				setPathEn("/en/");
				break;
			case "/en/":
				setPathGr("/");
				break;
			case "/about-us/":
				setPathEn("/en/about-us/");
				break;
			case "/en/about-us/":
				setPathGr("/about-us/");
				break;
			case "/contact-us/":
				setPathEn("/en/contact-us/");
				break;
			case "/en/contact-us/":
				setPathGr("/contact-us/");
				break;
			case "/our-work/":
				setPathEn("/en/our-work/");
				break;
			case "/en/our-work/":
				setPathGr("/our-work/");
				break;
			case "/mailchimp-certified-experts-athens-greece/":
				setPathEn("/en/mailchimp-certified-experts-athens-greece/");
				break;
			case "/en/mailchimp-certified-experts-athens-greece/":
				setPathGr("/mailchimp-certified-experts-athens-greece/");
				break;
			case "/think-videography/":
				setPathEn("/en/video-production/");
				break;
			case "/en/video-production/":
				setPathGr("/think-videography/");
				break;
			case "/kataskeyi-eshop-me-shopify/":
				setPathEn("/en/shopify-development/");
				break;
			case "/en/shopify-development/":
				setPathGr("/kataskeyi-eshop-me-shopify/");
				break;
			case "/prosopika-dedomena/":
				setPathEn("/en/privacy-policy/");
				break;
			case "/en/privacy-policy/":
				setPathGr("/prosopika-dedomena/");
				break;
			default:
				setPathGr("/");
				setPathEn("/en/");
		}
	}, [location.pathname]);

	return (
		<div className="locale-selector">
			<button
				className="locale-selector__btn"
				id="locale_selector"
				aria-label="Select locale"
			>
				<svg
					width="24"
					height="24"
					xmlns="http://www.w3.org/2000/svg"
					fillRule="evenodd"
					clipRule="evenodd"
				>
					<path d="M12.02 0c6.614.011 11.98 5.383 11.98 12 0 6.623-5.376 12-12 12-6.623 0-12-5.377-12-12 0-6.617 5.367-11.989 11.981-12h.039zm3.694 16h-7.427c.639 4.266 2.242 7 3.713 7 1.472 0 3.075-2.734 3.714-7m6.535 0h-5.523c-.426 2.985-1.321 5.402-2.485 6.771 3.669-.76 6.671-3.35 8.008-6.771m-14.974 0h-5.524c1.338 3.421 4.34 6.011 8.009 6.771-1.164-1.369-2.059-3.786-2.485-6.771m-.123-7h-5.736c-.331 1.166-.741 3.389 0 6h5.736c-.188-1.814-.215-3.925 0-6m8.691 0h-7.685c-.195 1.8-.225 3.927 0 6h7.685c.196-1.811.224-3.93 0-6m6.742 0h-5.736c.062.592.308 3.019 0 6h5.736c.741-2.612.331-4.835 0-6m-12.825-7.771c-3.669.76-6.671 3.35-8.009 6.771h5.524c.426-2.985 1.321-5.403 2.485-6.771m5.954 6.771c-.639-4.266-2.242-7-3.714-7-1.471 0-3.074 2.734-3.713 7h7.427zm-1.473-6.771c1.164 1.368 2.059 3.786 2.485 6.771h5.523c-1.337-3.421-4.339-6.011-8.008-6.771" />
				</svg>
			</button>
			<ul className="locale__list">
				<li className="locale__item">
					<Link to={pathGr} id="locale_gr">
						<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 480">
							<defs>
								<clipPath>
									<path fillOpacity=".67" d="M0 0h120v90H0z" />
								</clipPath>
							</defs>
							<g
								fillRule="evenodd"
								clipPath="url(#a)"
								transform="scale(5.33)"
								strokeWidth="1pt"
							>
								<path fill="#0d5eaf" d="M0 0h135v10H0z" />
								<path fill="#fff" d="M0 10h135v10H0z" />
								<path fill="#0d5eaf" d="M0 20h135v10H0z" />
								<path fill="#fff" d="M0 30h135v10H0z" />
								<path fill="#0d5eaf" d="M0 40h135v10H0z" />
								<path fill="#fff" d="M0 50h135v10H0z" />
								<path fill="#0d5eaf" d="M0 60h135v10H0z" />
								<path fill="#fff" d="M0 70h135v10H0z" />
								<path fill="#0d5eaf" d="M0 80h135v10H0zM0 0h50v50H0z" />
								<g fill="#fff">
									<path d="M20 0h10v50H20z" />
									<path d="M0 20h50v10H0z" />
								</g>
							</g>
						</svg>
						<span className="visually-hidden">Greek</span>
					</Link>
				</li>
				<li className="locale__item">
					<Link to={pathEn} id="locale_en">
						<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 480">
							<g fillRule="evenodd">
								<g strokeWidth="1pt">
									<path
										d="M0 0h912.01v36.923H0zm0 73.847h912.01v36.923H0zm0 73.847h912.01v36.923H0zm0 73.847h912.01v36.923H0zm0 73.846h912.01v36.924H0zm0 73.847h912.01v36.924H0zm0 73.847h912.01v36.924H0z"
										fill="#bd3d44"
									/>
									<path
										d="M0 36.923h912.01v36.924H0zm0 73.847h912.01v36.924H0zm0 73.847h912.01v36.924H0zm0 73.847h912.01v36.924H0zm0 73.847h912.01v36.923H0zm0 73.847h912.01v36.923H0z"
										fill="#fff"
									/>
								</g>
								<path fill="#192f5d" d="M0 0h364.8v258.46H0z" />
								<g fill="#fff">
									<path d="M30.4 11.063l3.32 10.214h10.74l-8.69 6.315 3.32 10.215-8.69-6.314-8.69 6.314 3.32-10.215-8.69-6.315h10.74zm60.8 0l3.32 10.214h10.742l-8.691 6.315 3.32 10.215-8.691-6.314-8.689 6.314 3.319-10.215-8.69-6.315h10.741zm60.802 0l3.32 10.214h10.741l-8.69 6.315 3.32 10.215-8.69-6.314-8.69 6.314 3.319-10.215-8.69-6.315h10.742zm60.8 0l3.318 10.214h10.74l-8.689 6.315 3.319 10.215-8.689-6.314-8.69 6.314 3.32-10.215-8.691-6.315h10.742zm60.8 0l3.32 10.214h10.741l-8.69 6.315 3.32 10.215-8.691-6.314-8.689 6.314 3.319-10.215-8.69-6.315h10.741zm60.802 0l3.32 10.214h10.741l-8.69 6.315 3.32 10.215-8.69-6.314-8.691 6.314 3.32-10.215-8.69-6.315h10.742zM60.802 36.909l3.318 10.215h10.742l-8.69 6.313 3.32 10.216-8.69-6.313-8.69 6.313 3.319-10.216-8.69-6.313h10.742zm60.798 0l3.32 10.215h10.74l-8.69 6.313 3.32 10.216-8.69-6.313-8.69 6.313 3.32-10.216-8.691-6.313h10.742zm60.802 0l3.319 10.215h10.742l-8.691 6.313 3.32 10.216-8.691-6.313-8.689 6.313 3.319-10.216-8.69-6.313h10.741zm60.801 0l3.32 10.215h10.741l-8.69 6.313 3.32 10.216-8.69-6.313-8.691 6.313 3.321-10.216-8.69-6.313h10.742zm60.8 0l3.318 10.215h10.74l-8.689 6.313 3.319 10.216-8.689-6.313-8.69 6.313 3.32-10.216-8.691-6.313h10.741zM30.4 62.755l3.32 10.215h10.74l-8.69 6.314L39.09 89.5l-8.69-6.313-8.69 6.313 3.32-10.215-8.69-6.314h10.74zm60.8 0l3.32 10.215h10.742l-8.691 6.314L99.89 89.5 91.2 83.186 82.511 89.5l3.319-10.215-8.69-6.314h10.741zm60.802 0l3.32 10.215h10.741l-8.69 6.314 3.32 10.215-8.69-6.313-8.69 6.313 3.319-10.215-8.69-6.314h10.742zm60.8 0l3.318 10.215h10.74l-8.689 6.314L221.49 89.5l-8.689-6.313-8.69 6.313 3.32-10.215-8.691-6.314h10.742zm60.8 0l3.32 10.215h10.741l-8.69 6.314 3.32 10.215-8.691-6.313-8.689 6.313 3.319-10.215-8.69-6.314h10.741zm60.802 0l3.32 10.215h10.741l-8.69 6.314 3.32 10.215-8.69-6.313-8.691 6.313 3.32-10.215-8.69-6.314h10.742zM60.802 88.601l3.318 10.216h10.742l-8.69 6.313 3.32 10.216-8.69-6.313-8.69 6.313 3.319-10.216-8.69-6.313h10.742zm60.798 0l3.32 10.216h10.74l-8.69 6.313 3.32 10.216-8.69-6.313-8.69 6.313 3.32-10.216-8.691-6.313h10.742zm60.802 0l3.319 10.216h10.742l-8.691 6.313 3.32 10.216-8.691-6.313-8.689 6.313 3.319-10.216-8.69-6.313h10.741zm60.801 0l3.32 10.216h10.741l-8.69 6.313 3.32 10.216-8.69-6.313-8.691 6.313 3.32-10.216-8.69-6.313h10.742zm60.8 0l3.318 10.216h10.74l-8.689 6.313 3.319 10.216-8.689-6.313-8.69 6.313 3.32-10.216-8.691-6.313h10.741zM30.4 114.448l3.32 10.215h10.74l-8.69 6.314 3.32 10.215-8.69-6.313-8.69 6.313 3.32-10.215-8.69-6.314h10.74zm60.8 0l3.32 10.215h10.742l-8.691 6.314 3.32 10.215-8.691-6.313-8.689 6.313 3.319-10.215-8.69-6.314h10.741zm60.802 0l3.32 10.215h10.741l-8.69 6.314 3.32 10.215-8.69-6.313-8.69 6.313 3.319-10.215-8.69-6.314h10.742zm60.8 0l3.318 10.215h10.74l-8.689 6.314 3.319 10.215-8.689-6.313-8.69 6.313 3.32-10.215-8.691-6.314h10.742zm60.8 0l3.32 10.215h10.741l-8.69 6.314 3.32 10.215-8.691-6.313-8.689 6.313 3.319-10.215-8.69-6.314h10.741zm60.802 0l3.32 10.215h10.741l-8.69 6.314 3.32 10.215-8.69-6.313-8.691 6.313 3.32-10.215-8.69-6.314h10.742zM60.802 140.294l3.318 10.216h10.742l-8.69 6.313 3.32 10.216-8.69-6.313-8.69 6.313 3.319-10.216-8.69-6.313h10.742zm60.798 0l3.32 10.216h10.74l-8.69 6.313 3.32 10.216-8.69-6.313-8.69 6.313 3.32-10.216-8.691-6.313h10.742zm60.802 0l3.319 10.216h10.742l-8.691 6.313 3.32 10.216-8.691-6.313-8.689 6.313 3.319-10.216-8.69-6.313h10.741zm60.801 0l3.32 10.216h10.741l-8.69 6.313 3.32 10.216-8.69-6.313-8.691 6.313 3.32-10.216-8.69-6.313h10.742zm60.8 0l3.318 10.216h10.74l-8.689 6.313 3.319 10.216-8.689-6.313-8.69 6.313 3.32-10.216-8.691-6.313h10.741zM30.4 166.14l3.32 10.216h10.74l-8.69 6.314 3.32 10.215-8.69-6.313-8.69 6.313 3.32-10.215-8.69-6.314h10.74zm60.8 0l3.32 10.216h10.742l-8.691 6.314 3.32 10.215-8.691-6.313-8.689 6.313 3.319-10.215-8.69-6.314h10.741zm60.802 0l3.32 10.216h10.741l-8.69 6.314 3.32 10.215-8.69-6.313-8.69 6.313 3.319-10.215-8.69-6.314h10.742zm60.8 0l3.318 10.216h10.74l-8.689 6.314 3.319 10.215-8.689-6.313-8.69 6.313 3.32-10.215-8.691-6.314h10.742zm60.8 0l3.32 10.216h10.741l-8.69 6.314 3.32 10.215-8.691-6.313-8.689 6.313 3.319-10.215-8.69-6.314h10.741zm60.802 0l3.32 10.216h10.741l-8.69 6.314 3.32 10.215-8.69-6.313-8.691 6.313 3.32-10.215-8.69-6.314h10.742zM60.802 191.988l3.318 10.216h10.742l-8.69 6.313 3.32 10.216-8.69-6.313-8.69 6.313 3.319-10.216-8.69-6.313h10.742zm60.798 0l3.32 10.216h10.74l-8.69 6.313 3.32 10.216-8.69-6.313-8.69 6.313 3.32-10.216-8.691-6.313h10.742zm60.802 0l3.319 10.216h10.742l-8.691 6.313 3.32 10.216-8.691-6.313-8.689 6.313 3.319-10.216-8.69-6.313h10.741zm60.801 0l3.32 10.216h10.741l-8.69 6.313 3.32 10.216-8.69-6.313-8.691 6.313 3.32-10.216-8.69-6.313h10.742zm60.8 0l3.318 10.216h10.74l-8.689 6.313 3.319 10.216-8.689-6.313-8.69 6.313 3.32-10.216-8.691-6.313h10.741zM30.4 217.834l3.32 10.215h10.74l-8.69 6.314 3.32 10.215-8.69-6.313-8.69 6.313 3.32-10.215-8.69-6.314h10.74zm60.8 0l3.32 10.215h10.742l-8.691 6.314 3.32 10.215-8.691-6.313-8.689 6.313 3.319-10.215-8.69-6.314h10.741zm60.802 0l3.32 10.215h10.741l-8.69 6.314 3.32 10.215-8.69-6.313-8.69 6.313 3.319-10.215-8.69-6.314h10.742zm60.8 0l3.318 10.215h10.74l-8.689 6.314 3.319 10.215-8.689-6.313-8.69 6.313 3.32-10.215-8.691-6.314h10.742zm60.8 0l3.32 10.215h10.741l-8.69 6.314 3.32 10.215-8.691-6.313-8.689 6.313 3.319-10.215-8.69-6.314h10.741zm60.802 0l3.32 10.215h10.741l-8.69 6.314 3.32 10.215-8.69-6.313-8.691 6.313 3.32-10.215-8.69-6.314h10.742z" />
								</g>
							</g>
						</svg>
						<span className="visually-hidden">English</span>
					</Link>
				</li>
			</ul>
		</div>
	);
};

export default LocaleSelector;
